import { z } from 'zod';
import { JobStatusSchema, JobTypeSchema } from '../enums.js';
import { IdSchema, IsoDateTimeSchema } from './common.js';
/** jobs/{jobId} — long-running LLM operations. The client watches this doc live rather than
 * holding an HTTP connection open. See docs/PLAN.md §2.4. */
export const JobSchema = z.object({
    id: IdSchema,
    type: JobTypeSchema,
    status: JobStatusSchema.default('queued'),
    orgId: IdSchema,
    projectId: IdSchema.optional(),
    progress: z.number().min(0).max(1).default(0),
    result: z.record(z.string(), z.unknown()).nullable().default(null),
    error: z.string().nullable().default(null),
    createdByUid: IdSchema,
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
//# sourceMappingURL=job.js.map